<p-button
    icon="pi pi-book"
    [label]="label"
    [outlined]="true"
    severity="info"
    size="small"
    pTooltip="Tours guiados y guía del módulo"
    tooltipPosition="bottom"
    (onClick)="open()"
></p-button>

<p-dialog
    [header]="'Ayuda — ' + moduleName"
    [(visible)]="visible"
    [modal]="true"
    [style]="{ width: '80vw' }"
    [breakpoints]="{ '960px': '95vw' }"
    [maximizable]="true"
    [dismissableMask]="true"
    styleClass="module-help-dialog"
>
    <div class="help-container">
        <div class="help-sidebar">
            <p-menu [model]="menuItems" styleClass="help-menu"></p-menu>
        </div>

        <div class="help-content">
            <!-- Tours guiados -->
            <ng-container *ngIf="selectedId === 'tours'">
                <h5 class="help-heading">Tours guiados</h5>
                <p class="text-color-secondary mt-0">
                    Cada tour va señalando la pantalla paso por paso. Puedes salir cuando
                    quieras con <b>Esc</b> y moverte con las flechas del teclado.
                </p>
                <p-divider></p-divider>

                <div class="help-tours">
                    <div class="help-tour" *ngFor="let tour of availableTours">
                        <i [class]="tour.icon"></i>
                        <div class="help-tour__text">
                            <div class="help-tour__title">{{ tour.title }}</div>
                            <small class="text-color-secondary" *ngIf="tour.description">
                                {{ tour.description }}
                            </small>
                        </div>
                        <p-button
                            label="Iniciar"
                            icon="pi pi-play"
                            size="small"
                            [text]="true"
                            (onClick)="startTour(tour)"
                        ></p-button>
                    </div>

                    <div class="text-color-secondary" *ngIf="!availableTours.length">
                        No hay tours disponibles con tus permisos actuales.
                    </div>
                </div>
            </ng-container>

            <!-- Secciones de referencia -->
            <ng-container *ngIf="selectedSection as section">
                <h5 class="help-heading">{{ section.title }}</h5>
                <p-divider></p-divider>
                <div class="help-html" [innerHTML]="section.html"></div>
            </ng-container>
        </div>
    </div>
</p-dialog>
